var _a, _b;
import { getParamsQueryString } from '../helpers';
const ACT_LOADMORE_CATEGORY = 'ACT_LOADMORE_CATEGORY';
let params = getParamsQueryString();
let btnLoadmore = document.querySelector('.loadMoreCategory');
let wrapList = document.querySelector('.loadMore_list');
let slug = (_a = document.querySelector('.loadMoreCategory')) === null || _a === void 0 ? void 0 : _a.getAttribute('data-slug');
let taxonomy = (_b = document.querySelector('.loadMoreCategory')) === null || _b === void 0 ? void 0 : _b.getAttribute('data-taxonomy');
export const LoadMoreCategoryData = {
    type: ACT_LOADMORE_CATEGORY,
    wrapList: wrapList ? wrapList : null,
    btnLoadmore: btnLoadmore ? btnLoadmore : null,
    paged: 2,
    payload: {
        action: 'load_post',
        params: params,
        slug: slug ? slug : null,
        taxonomy: taxonomy ? taxonomy : null
    }
};
